import React from 'react'
import { useGLTF } from '@react-three/drei'

import OmbrelloneGenerale from './OmbrelloneGenerale'

export function OmbrelloneBraccioAvantage() {
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioAvantage.gltf`); 

  return (
    <OmbrelloneGenerale nodeCorpoName={nodes.Object028.geometry} 
                        nodeTeloName={nodes.Object006.geometry}                         
                        pos1={[0, 0, 0]}
                        rot1={[-Math.PI / 2, 0, 0]}
                        pos2={[0, 0, -0.004]}
                        rot2={[-Math.PI / 2, 0, 0]}  
                        sc1={0.00025}
                        sc2={0.00025}      
                        mainRotation={[Math.PI / 2, 0, 0]}              
    />
  )
}

export function OmbrelloneBraccioAvantageMantovana() { 
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioAvantageMantovana.gltf`);
    
  return (
    <OmbrelloneGenerale nodeCorpoName={nodes.Object289.geometry} 
                        nodeTeloName={nodes.Object272.geometry}                        
                        pos1={[0, 0, 0]}
                        rot1={[-Math.PI / 2, 0, 0]}
                        pos2={[0, 0, -0.004]}
                        rot2={[-Math.PI / 2, 0, 0]}  
                        sc1={0.00025}
                        sc2={0.00025}      
                        mainRotation={[Math.PI / 2, 0, 0]}              
    />
  )
}

useGLTF.preload(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioAvantage.gltf`)
useGLTF.preload(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioAvantageMantovana.gltf`)


